module.exports = __webpack_public_path__ + "img/diners.30d5b353.svg";